import React from 'react';
import { useBrandConfig } from '../../Theme/useBrandTheme';
import { getBrandAsset } from '../../Utils/assetLoader';
import { ENV_TEACHR, isBrandActive } from '../../config/environment.config';

interface BrandLogoProps {
  className?: string;
  variant?: 'default' | 'white';
  onClick?: () => void;
  alt?: string;
  width?: string | number;
  height?: string | number;
}

/**
 * Composant qui affiche automatiquement le logo de la marque détectée
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  variant = 'default',
  onClick,
  alt,
  width,
  height
}) => {
  const brandConfig = useBrandConfig();
  
  // Déterminer quel logo utiliser
  const logoSrc = variant === 'white' 
    ? brandConfig.assets.logoWhite 
    : brandConfig.assets.logo;
  const logoMobileSrc = isBrandActive(ENV_TEACHR) ? logoSrc : (variant === 'white' 
    ? brandConfig.assets.faviconWhite 
    : brandConfig.assets.favicon)

  
  // Fallback vers l'asset de la marque si le chemin dans la config n'est pas trouvé
  const finalLogoSrc = logoSrc.startsWith('/brands/') 
    ? logoSrc 
    : getBrandAsset(variant === 'white' ? 'logo-white.svg' : 'logo.svg');
  const finalLogoSrc2 = logoMobileSrc.startsWith('/brands/') 
    ? logoMobileSrc 
    : getBrandAsset(variant === 'white' ? 'logo-white.svg' : 'logo.svg');
  
  const defaultAlt = alt || `${brandConfig.displayName} logo`;
  
  const style: React.CSSProperties = {
    cursor: onClick ? 'pointer' : 'default',
    ...(width && { width: typeof width === 'number' ? `${width}px` : width }),
    ...(height && { height: typeof height === 'number' ? `${height}px` : height })
  };
  return (
    <>
    <img
      src={ finalLogoSrc}
      alt={defaultAlt}
      className={`${className} lg:block hidden`}
      style={style}
      onClick={onClick}
      onError={(e) => {
        // Fallback vers le logo Teach'r par défaut en cas d'erreur
        const target = e.target as HTMLImageElement;
        target.src = '/brands/teachr/logo.svg';
        console.warn(`Logo not found for brand ${brandConfig.name}, using fallback`);
      }}
    />
    <img
      src={finalLogoSrc2}
      alt={defaultAlt}
      className={`${className} lg:hidden ${ isBrandActive(ENV_TEACHR) ? 'w-20' : 'w-10 h-10' }`}
      style={style}
      onClick={onClick}
      // onError={(e) => {
      //   // Fallback vers le logo Teach'r par défaut en cas d'erreur
      //   const target = e.target as HTMLImageElement;
      //   target.src = '/brands/teachr/logo.svg';
      //   console.warn(`Logo not found for brand ${brandConfig.name}, using fallback`);
      // }}
    />
    </>
  );
};

/**
 * Composant BrandLogo avec des props par défaut pour la navigation
 */
export const BrandLogoNav: React.FC<Omit<BrandLogoProps, 'onClick'>> = (props) => {
  const handleClick = () => {
    window.location.href = '/';
  };

  return <BrandLogo {...props} onClick={handleClick} />;
};

/**
 * Composant BrandLogo avec des props par défaut pour les en-têtes
 */
export const BrandLogoHeader: React.FC<BrandLogoProps> = (props) => {
  return (
    <BrandLogo
      {...props}
      className={`${props.className || ''} cursor-pointer`}
      width={props.width || 129}
      height={props.height || 'auto'}
    />
  );
};

export default BrandLogo;




